import { useFirestore, useFirestoreDocData } from 'reactfire';
import { doc } from "firebase/firestore";

function useImageDoc(id) {
  const firestore = useFirestore();
  const ref = doc(firestore, "images", id);
  return useFirestoreDocData(ref);
}

export default useImageDoc;